import { defineAsyncComponent } from "vue";
import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import AuthenticationHelper from "../helper/OIDCManager";
import { appAbility } from "../services/Ability";
import { useFeatureLot } from "../composables/FeatureLotComposable";
import { reloadOnceAfterDeploy, isChunkLoadError } from "../helper/deployReload";


const routes = [
  {
    name: "Home",
    path: "/",
    component: () => import("../components/Home/Home.vue"),
    meta: {
      requiresAuth: true, //A rajouter pour toutes les routes qui nécessitent l'authentification
    },
  },
  {
    name: "Animal",
    path: "/ListeAnimaux",
    component: () => import("../views/Animal/Animal.vue"),
    meta: {
      requiresAuth: true, //A rajouter pour toutes les routes qui nécessitent l'authentification
    },
  },
  {
    name: "Production",
    path: "/Production",
    component: () => import("../views/Production/SearchModal/SearchAnimalModal.vue"),
    meta: {
      requiresAuth: false, //A rajouter pour toutes les routes qui nécessitent l'authentification
      lot : "LOT2"
    },
  },
  {
    name:"Collaborateur",
    path : "/ListeCollaborateurs",
    component : () => import("../views/Agent/AgentListView.vue"),
    meta : {
      requiresAuth: false,
      lot : "LOT2"
    }
  },
  {
    name:"TypePoudres",
    path: "/ListeTypePoudres",
    component : () => import("../views/PowderType/PowderTypeListView.vue"),
    meta : {
      requiresAuth: false, // TODO
      lot : "LOT2"
    }
  },
  {
    name:"Dilueur",
    path: "/ListeDilueurs",
    component : () => import("../views/DilutorBath/DilutorBathListView.vue"),
    meta : {
      requiresAuth: false, // TODO
      lot : "LOT2"
    }
  },
  {
    name:"EtalonnagePhotocolorimetre",
    path: "/EtalonnagePhotocolorimetre",
    component : () => import("../views/Photocolorimeter/PhotocolorimeterCalibration.vue"),
    meta : {
      requiresAuth: true, // TODO
      lot : "LOT2"
    }
  },
  {
    name:"ListeEvenementsPrelevement",
    path: "/ListeEvenementsPrelevement",
    component : () => import("../views/EventsProd/EventsProdListView.vue"),
    meta : {
      requiresAuth: true, // TODO
      lot : "LOT2"
    }
  },
  {
    name:"ControlDilueur",
    path: "/ControlDilueurs",
    component : () => import("../views/DilutorControl/DilutorControlListView.vue"),
    meta : {
      requiresAuth: true, // TODO
      lot : "LOT2"
    }
  },
  {
    name: "TiersProvider",
    path: "/ListeProvider",
    component: defineAsyncComponent(
      () => import("../views/ThirdParty/ThirdParties.vue")
    ),
    props: { TypeTiers: "PROVIDER" },
    meta: {
      requiresAuth: true, //A rajouter pour toutes les routes qui nécessitent l'authentification
    },
  },
  {
    name: "ListeReserve",
    path: "/ListeReserve",
    component: defineAsyncComponent(
      () => import("../views/Reservation/Reservation.vue")
    ),
    meta: {
      requiresAuth: true, //A rajouter pour toutes les routes qui nécessitent l'authentification
    },
  },
  {
    name:'ListeCaryotype',
    path: '/ListeCaryotype',
    component: defineAsyncComponent(() => import('../views/Karyotype/Karyotype.vue')),
    meta: {
      requiresAuth: false, //A rajouter pour toutes les routes qui nécessitent l'authentification
    }
  },
  {
    name:'ListeLames',
    path: '/ListeLames',
    component: defineAsyncComponent(() => import('../views/Blade/BladeListView.vue')),
    meta: {
      requiresAuth: false, //A rajouter pour toutes les routes qui nécessitent l'authentification
      lot : "LOT2"
    }
  },
  {
    name: "TiersOwner",
    path: "/ListeOwner",
    component: defineAsyncComponent(
      () => import("../views/ThirdParty/ThirdParties.vue")
    ),
    props: { TypeTiers: "OWNER" },
    meta: {
      requiresAuth: true, //A rajouter pour toutes les routes qui nécessitent l'authentification
    },
  },
  {
    name: "Centre",
    path: "/ListeCentres",
    component: () => import("../views/Center/Center.vue"),
    meta: {
      requiresAuth: true, //A rajouter pour toutes les routes qui nécessitent l'authentification
    },
  },
  {
    name: "ListeParametres",
    path: "/ListeParametres",
    component: () => import("../views/Parameter/ParameterListView.vue"),
  },
  {
    name: "InfoUser",
    path: "/InfoUser",
    component: () => import("../views/User/User.vue"),
  },
  {
    name: "OptionUser",
    path: "/OptionUser",
    component: () => import("../views/Options/OptionsListView.vue"),
    meta: {
      requiresAuth: true, //A rajouter pour toutes les routes qui nécessitent l'authentification
    },
  },
  {
    name: "ListeCTG",
    path: "/ListeCTG",
    component: () => import("../views/CTG/CTG.vue"),
    meta: {
      requiresAuth: true, //A rajouter pour toutes les routes qui nécessitent l'authentification
    },
  },
  {
    name: "ListeInterventions",
    path: "/ListeInterventions",
    component: () => import("../views/Intervention/Intervention.vue"),
    meta: {
      requiresAuth: true, //A rajouter pour toutes les routes qui nécessitent l'authentification
    },
  },
  {
    name: "ListeElevage",
    path: "/ListeElevage",
    component: () => import("../views/BreedingStud/Elevage.vue"),
    meta: {
      requiresAuth: true, //A rajouter pour toutes les routes qui nécessitent l'authentification
    },
  },
  {
    name: "ListeMutation",
    path: "/ListeMutation",
    component: () => import("../views/MutationAnimal/MutationAnimal.vue"),
    meta: {
      requiresAuth: true, //A rajouter pour toutes les routes qui nécessitent l'authentification
    },
  },
  {
    name: "ListeSyneliaConnect",
    path: "/ListeSyneliaConnect",
    component: () => import("../components/ListeSyneliaConnect.vue"),
    meta: {
      requiresAuth: true, //A rajouter pour toutes les routes qui nécessitent l'authentification
    },
  },
  {
    name: "Components",
    path: "/Components",
    component: defineAsyncComponent(
      () => import("../views/Utilities/Components.vue")
    ),
    meta: {
      requiresAuth: true, //A rajouter pour toutes les routes qui nécessitent l'authentification
    },
  },
  {
    name: "TestMesure",
    path: "/TestMesure",
    component: defineAsyncComponent(
      () => import("../components/TestMesure.vue")
    ),
    meta: {
      requiresAuth: false, //A rajouter pour toutes les routes qui nécessitent l'authentification
    },
  },
  {
    name: "Reforms",
    path: "/ListeReformes",
    component: () => import("../views/Reform/ReformListView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "ListeCommande",
    path: "/ListeCommande",
    component: defineAsyncComponent(() => import("../views/Order/Order.vue")),
    meta: {
      requiresAuth: true, //A rajouter pour toutes les routes qui nécessitent l'authentification
    },
  },
  {
    name: "ListeHistoriqueStatutCommande",
    path: "/ListeHistoriqueStatutCommande",
    component: defineAsyncComponent(
      () => import("../views/OrderStatusHistory/OrderStatusHistory.vue")
    ),
    meta: {
      requiresAuth: true, //A rajouter pour toutes les routes qui nécessitent l'authentification
    },
  },
  {
    name: "PreparationReforms",
    path: "/PreparationReformes",
    component:
      () => import("../views/Reform/PreparationListView.vue"),
    meta: {
      requiresAuth: false,
    },
  },
  {
    name: "ListePrelevements",
    path: "/ListePrelevements",
    component: () => import("../views/Ejaculate/EjaculateListView.vue"),
    meta : {
      requiresAuth: true,
      lot:"LOT2"
    }
  },
  {
    name: "ListeHeterospermie",
    path: "/ListeHeterospermie",
    component: () => import("../views/Fabrication/HeterospermieListView.vue"),
    meta : {
      requiresAuth: true,
      lot : "LOT3"
    }
  },
  {
    name: "ListeConsultationStock",
    path: "/ListeConsultationStock",
    component: () => import("../views/Stock/StockListView.vue"),
    meta : {
      requiresAuth: true,
      lot: "LOT3",
    }
  },
  {
    name: "SuiviFabrication",
    path: "/SuiviFabrication",
    component: () => import("../views/Fabrication/suiviFabrication/SuiviFabricationListView.vue"),
    meta : {
      requiresAuth: true,
      lot:"LOT3"
    }
  },
  {
    name: "SuiviQualite",
    path: "/SuiviQualite",
    component: () => import("../views/Quality/QualityView.vue"),
    meta : {
      requiresAuth: true,
      lot : "LOT2"
    }
  },
  {
    name: "PlanMonte",
    path: "/PlanMonte",
    component: () => import("../views/MountingPlan/MountingPlanView.vue"),
    meta : {
      requiresAuth: true,
      lot: "LOT4"
    },
  },
  {
    name: "ListeBatiments",
    path: "/ListeBatiments",
    component: () => import("../views/Building/BuildingListView.vue"),
    meta : {
      requiresAuth: true,
      lot:"LOT4"
    }
  },
  {
    name: "ListeDevices",
    path: "/ListeDevices",
    component: () => import("../views/Device/DeviceListView.vue"),
    meta : {
      requiresAuth: true,
      lot : "LOT2"
    }
  },
  {
    name: "GestionRessources",
    path: "/GestionRessources",
    component: () => import("../views/Resources/ResourceManagement.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    name: "TestPerformance",
    path: "/TestPerfs",
    component: () => import("../views/TestPerfs/PerfStore.vue"),
    meta : {
      requiresAuth: false,
    }
  },
  {
    name: "TestClaude",
    path: "/TestClaude",
    component: () => import("../views/TestPerfs/ClaudeStore.vue"),
    meta : {
      requiresAuth: false,
    }
  },
  {
    name: "signin",
    path: "/signin-oidc",
    component: () => import("../views/User/SigninOidc.vue"),
  },
  {
    name: "signout",
    path: "/signout-oidc",
    component: () => import("../views/User/SignoutOidc.vue"),
  },
  {
    name: "silent-callback",
    path: "/silent-callback",
    component: () => import("../views/User/SilentCallback.vue"),
  },
  {
    name: "404NotFound",
    path: "/:pathMatch(.*)*",
    component: () => import("../views/StatusCodePage/404NotFound.vue"),
  },
  {
    name: "403Forbidden",
    path: "/403Forbidden",
    component: () => import("../views/StatusCodePage/403Forbidden.vue"),
  },
  {
    name: "403Admin",
    path: "/403Admin",
    component: () => import("../views/StatusCodePage/403Admin.vue"),
  },
  {
    name: "StartupError",
    path: "/StartupError",
    component: () => import("../views/StatusCodePage/StartupError.vue"),
  },
];

const router = createRouter({ history: createWebHashHistory(), routes });
router.beforeEach(async (to, from) => {

  // Authentification : uniquement sur les routes protégées
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    let user = await AuthenticationHelper._userManager.getUser();

    // Si l'utilisateur n'est pas connecté, on le redirige vers l'écran de connexion
    if (!user) {
      await AuthenticationHelper._userManager.signinRedirect();
      return false;
    }

    // Si le token est expiré, on tente un silent refresh avant de continuer
    if (user.expired) {
      try {
        await AuthenticationHelper._userManager.signinSilent();
      } catch (error) {
        console.error("Silent refresh échoué", error);
        await AuthenticationHelper._userManager.signinRedirect();
        return false;
      }
    }

    // Pas de vérification de droit pour la page d'accueil
    if (to.path === "/") {
      return true;
    }
  }

  // Droits CASL : sur toutes les routes sauf les pages d'auth, d'erreur et silent-callback
  const name = to.name?.toString();
  const isAuthRoute = name === "signin" || name === "signout" || name === "silent-callback";
  const isErrorRoute = name?.includes("403") || name?.includes("404") || name === "StartupError";

  if (!isAuthRoute && !isErrorRoute) {
    if (appAbility.rules.length === 0) {
      return { name: "403Admin" };
    }
    if (name !== "Home") {
      if (to.meta.requiresAuth === true && !appAbility.can("access", "global#page#" + to.path.substring(1))) {
        return { name: "403Forbidden" };
      }
    }

    // Feature-gating par lot : vérifie que le centre actif a accès au lot de la route
    if (to.meta.lot) {
      const { canAccessRoute } = useFeatureLot();
      if (!canAccessRoute(to.meta)) {
        return { name: "403Forbidden" };
      }
    }
  }
});

// Récupération auto après déploiement (Mantis 0028073) : si le chargement d'une vue lazy
// échoue parce que son chunk hashé n'existe plus (nouvelle version déployée), on force un
// rechargement unique pour récupérer la version courante au lieu d'une navigation cassée.
router.onError((error) => {
  if (isChunkLoadError(error)) {
    reloadOnceAfterDeploy("router.onError:chunk");
  }
});

export default router;
